// Install local licensed files and a rights declaration here. No network fetch,
// empty menu or original-music claim is made when no assets have been provided.
export interface LicensedManifest { rights:string; tracks:Record<'play'|'start'|'home'|'death'|'level'|'gameOver',string> }
export const licensedManifest:LicensedManifest|null=null;
export async function loadLicensed(context:AudioContext,manifest:LicensedManifest|null):Promise<Map<string,AudioBuffer>|null>{
  if(!manifest?.rights.trim())return null;
  const result=new Map<string,AudioBuffer>();
  try {
    for(const [key,path]of Object.entries(manifest.tracks)){
      if(!path.startsWith('/audio/')||path.includes('..')||path.includes('?'))return null;
      const response=await fetch(path);if(!response.ok)return null;
      result.set(key,await context.decodeAudioData(await response.arrayBuffer()));
    }
    return result.size===6?result:null;
  }catch{return null;}
}
